export const findSubstring = (word = "", wordToBeSearched = "") => {
    if (word.toLowerCase().includes(wordToBeSearched.toLowerCase())) {
        return true;
    }
    return false;
};
